import React, { useEffect, useState } from 'react';
import { Button, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { InputWithError } from 'common/InputWithError';
import { SpinnerButton } from 'common/SpinnerButton';

export const AddDomainModal = ({ isOpen, toggle, handleAddDomain }) => {
    const [domain, setDomain] = useState('');

    const handleSubmit = async () => {
        const params = { domain };

        await handleAddDomain(params);
        toggle();
    };

    useEffect(() => {
        setDomain('');
    }, [isOpen]);

    return (
        <div>
            <Modal isOpen={isOpen} className="modal-md">
                <ModalHeader toggle={toggle}>Add Domain</ModalHeader>
                <ModalBody style={{ paddingBottom: '2rem' }}>
                    <div>
                        <Label className="mr-2 mb-0">
                            Domain Name:
                        </Label>
                        <div>
                            <InputWithError
                                name="domainName"
                                value={domain}
                                type="text"
                                onChange={setDomain}
                                errorObj={null}
                                marginBottomClass="mb-3"
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                    <SpinnerButton
                        type='modal'
                        color='primary'
                        onClick={handleSubmit}
                        title='Create'
                    />
                </ModalFooter>
            </Modal>
        </div>
    );
};
